// @noflow
import { PickerContainer } from './style';
import * as React from 'react';
import Spinner from '~/components/widgets/temperature-spinner/dual-color-range/';
import Temperature from '~/components/widgets/temperature';

export const getValueColor = ({ value }) => (value.get('cool') > 26 ? 'rgb(66, 168, 118)' : 'rgb(69, 180, 255)');

export const getValueLabel = ({ value }) => <Temperature element="tspan" value={value.get('cool')} />;

export const hasPicker = () => true;

export const getPicker = ({ config, productProps, value, updateValue }) => {
    const minCool = productProps.get('minCool') || config.getIn(['products', 'cooling', 'minTemp']);
    const maxCool = productProps.get('maxCool') || config.getIn(['products', 'cooling', 'maxTemp']);
    return (
        <PickerContainer>
            <Spinner
                controlMode="COOL"
                currentTemp={value.get('cool')}
                handleChangeTemp={newCoolValue => updateValue(value.set('cool', newCoolValue))}
                maxCool={maxCool}
                minCool={minCool}
            />
        </PickerContainer>
    );
};

export const defaultEventValue = { cool: 25.5 };

const defaultDaySchedule = [
    { value: { cool: 25.5 }, start: 360 },
    { value: { cool: 29.5 }, start: 480 },
    { value: { cool: 29.5 }, start: 720 },
    { value: { cool: 29.5 }, start: 840 },
    { value: { cool: 25.5 }, start: 1080 },
    { value: { cool: 28 }, start: 1320 }
];

export const getDefaultSchedule = () => ({
    monday: defaultDaySchedule,
    tuesday: defaultDaySchedule,
    wednesday: defaultDaySchedule,
    thursday: defaultDaySchedule,
    friday: defaultDaySchedule,
    saturday: defaultDaySchedule,
    sunday: defaultDaySchedule
});



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/na-thermostat-cool/index.js